import { jsx as _jsx } from "react/jsx-runtime";
import { cn } from '../../../utils';
export function FormFieldGroup({ children, className }) {
    return (_jsx("div", { className: cn('flex flex-col gap-stack-tight w-full', className), children: children }));
}
